<template>
  <form
    class="template notification-center-page__form"
    v-on:submit.prevent="onSubmit"
  >
    <section class="notification-center-page__form__section">
      <h4>Настройки</h4>
      <input-text
        class="template__name"
        maxlength="100"
        minlength="3"
        placeholder="Название рассылки"
        required="required"
        v-bind:title="'Название'"
        v-model="name"
        v-bind:violations="nameInputErrors"
      />
      <the-select
        class="template__event"
        required="required"
        v-bind:option-title-key="'name'"
        v-bind:option-value-key="'id'"
        v-bind:options="events"
        v-bind:placeholder="'Выберите событие'"
        v-bind:title="'Событие'"
        v-bind:violations="eventInputErrors"
        v-model="eventId"
        v-on:input="onChangeEvent" />
      <span v-if="eventId === $options.eventBirthDate">
        Отправка производится ежедневно в 12 часов дня.
      </span>
      <the-select
        v-if="showDispatchTimeSelector"
        class="template__event"
        required="required"
        v-bind:options="dispatchTimes.toArray()"
        v-bind:placeholder="'Выберите время отправки'"
        v-bind:title="'Время отправки'"
        v-bind:violations="dispatchTimeInputErrors"
        v-model="dispatchTime" />
      <date-time-picker
        required="required"
        v-if="eventId === $options.eventByDate"
        title="Выберите дату и время отправки"
        class="notification-center-page__date-time-select"
        sub-title="Дата и время отправки"
        v-bind:with-minutes="false"
        v-bind:initial-date="dispatchTime"
        v-bind:violations="dispatchTimeInputErrors"
        v-on:submit="onChangeTime"
      />
      <the-select
        class="template__event"
        option-title-key="name"
        option-value-key="value"
        required="required"
        title="Канал"
        placeholder="Каналы отправки"
        v-bind:options="channels"
        v-bind:violations="channelsInputErrors"
        v-on:input="onChangeOptions"
        v-model="selectedChannel" />
      <multiple-autocomplete-input
        v-if="isSelectedMessengersChannel"
        v-model="selectedDispatchRouting"
        chips
        item-text="title"
        item-value="value"
        label="Мессенджеры"
        multiple
        removal-per-chip
        select-all-text="Все мессенджеры"
        set-select-all-option
        small-chips
        v-bind:items="dispatchRoutingOptions" />
      <p
        class="text__violation"
        role="alert"
        v-for="violationText in dispatchRoutingInputErrors"
        v-bind:key="violationText"
      >{{ violationText }}</p>
      <div
        v-if="eventId === $options.eventByDate"
        class="notification-center-page__switch"
      >
        <v-switch
          v-model="repeatable"
        />
        <span>Повторяемый</span>
      </div>
      <input-checkbox
        v-if="eventId === $options.eventUpcomingVisit && dispatchTime === 'за сутки до визита'"
        v-model="sendOnWeekends"
        title="Отправлять в выходные"
      />
    </section>
    <section v-if="hasFragments" class="notification-center-page__form__section">
      <h4>Сообщение</h4>
      <p>Добавьте переменную</p>
      <div class="notification-center-page__chips">
        <v-chip
          v-for="fragment in fragmentTypesWithoutText"
          v-bind:disabled="isMaxLengthRough"
          v-bind:key="fragment.id"
          class="notification-center-page__chip"
          v-on:click="onAddFragment(fragment)"
        >
          {{ fragment.id }}
        </v-chip>
      </div>
      <textarea-length-limitation
        title="Текст сообщения"
        rows="4"
        v-bind:value="roughValue"
        v-bind:is-show-tooltip="isSelectSmsChannel"
        v-bind:text-hint="$options.smsChannelDescription"
        v-on:input="onUpdateRoughValue"
        v-on:cursor-position="onUpdateCursorPositions"
        v-bind:maxLength="maxLengthText"
        ref='textarea'
        placeholder="Текст сообщения"
        v-bind:violations="fragmentsInputErrors"
      />
    </section>
    <section
      v-if="shownBlockOptions"
      class="notification-center-page__form__section">
      <h4 v-if="isSelectSmsChannel">
        {{ descriptionNotifiablePatients ? `Получатели (${descriptionNotifiablePatients})` : 'Получатели' }}
        <span v-if="showCountNotifiablePatients">
          : {{ countNotifiablePatients }}
        </span>
      </h4>
      <div v-if="shownOptions" class="notification-center-page__form__group-row">
        <the-select
          class="template__event"
          required="required"
          option-title-key="title"
          option-value-key="value"
          v-bind:clearable="true"
          v-bind:options="sexOptions"
          placeholder="Не указан"
          title="Пол"
          v-model="sexId"
          v-on:input="onChangeOptions"
        />
        <div class="recipients-date">
          <span class="recipients-date__title">Дата последнего визита</span>
          <date-picker-dialog
            range
            v-bind:value="period"
            v-on:input="onInputPeriod"
            v-on:close="onCloseDatePickerDialog"
          >
            <template v-slot:trigger="{ listenerObject }">
              <button
                class="recipients-date__button-calendar"
                type="button"
                v-on="listenerObject"
              >
                <span v-if="period.length">{{ periodTitle }}</span>
                <span
                  v-else
                  class="recipients-date__button-calendar__placegolder"
                >
                  {{ $options.placeholderDate }}
                </span>
              </button>
            </template>
          </date-picker-dialog>
        </div>
      </div>
      <autocomplete-input
        v-if="shownOptions"
        item-text="title"
        item-value="value"
        title="Услуга"
        label="Выберите услугу"
        style-mis
        v-bind:menu-props="{ maxWidth: 'min(80%, 586px)' }"
        v-bind:items="serviceOptions"
        v-bind:violations="serviceInputErrors"
        v-bind:clearable="true"
        v-model="service"
        v-on:input="onChangeOptions"
        solo />
      <the-select
        v-if="shownOptions"
        title="Воронка"
        placeholder="Выберите воронку"
        v-bind:clearable="true"
        v-bind:options="funnelOptions"
        v-model="funnel"
        v-on:input="handleFunnelInput"
        v-bind:violations="funnelInputErrors" />
      <the-select
        v-bind:clearable="true"
        v-if="funnel && shownOptions"
        placeholder="Выберите этап"
        v-bind:options="funnelStageOptions"
        v-model="stage"
        v-on:input="onChangeOptions"
        v-bind:violations="stageInputErrors" />
    </section>
    <section
      v-if="canEnableAutoConfirm"
      class="notification-center-page__form__section"
    >
      <h4>Автоподтверждение</h4>
      <input-checkbox
        v-model="isEnableAutoConfirm"
        v-bind:title="'Автоподтверждение приёма'"
      />
      <template v-if="isShowAutoConfirmOptions">
        <input-text
          v-model="autoConfirmTextConfirm"
          v-bind:placeholder="'Приду'"
          v-bind:title="'Текст подтверждения'"
          v-bind:violations="confirmTextInputErrors"
          v-bind:maxlength="100"
        />
        <input-text
          v-model="autoConfirmTextRefuse"
          v-bind:placeholder="'Не приду'"
          v-bind:title="'Текст отмены/переноса'"
          v-bind:violations="refuseTextInputErrors"
          v-bind:maxlength="100"
        />
      </template>
    </section>
    <div class="template__control-buttons">
      <button
        class="template__cancel"
        type="button"
        v-on:click="() => $emit('cancel')"
      >Отмена</button>
      <button
        class="template__submit"
        type="submit"
      >Сохранить</button>
    </div>
  </form>
</template>
<script>
import { List, Maybe } from 'monet';
import notifierMixin from '@/mixins/notifierMixin';
import InputText from '@/components/InputText.vue';
import TheSelect from '@/components/TheSelect.vue';
import smsTemplateMixin, { templateFragmentComponents } from '@/mixins/notificationPlanMixin';
import { NotificationPlanCreationRequest } from '@/storage/gateways/NotificationPlansGateway';
import DateTimePicker from '@/components/DateTimePicker.vue';
import { formatDate } from '@/utils/timeFormat';
import DatePickerDialog from '@/components/DatePickerDialog.vue';
import AutocompleteInput from '@/components/AutocompleteInput.vue';
import formMeaningfulFieldsMixin from '@/mixins/formMeaningfulFieldsMixin';
import TextareaLengthLimitation from '@/components/TextareaLengthLimitation.vue';
import InputCheckbox from '@/components/InputCheckbox.vue';
import MultipleAutocompleteInput from '@/components/MultipleAutocompleteInput.vue';

/**
 * @description Описание СМС-канала рассылки.
 * @type {string}
 */
const SMS_CHANNEL_DESCRIPTION = 'По международному стандарту, 1 СМС = 70 символов. В\u00A0длине сообщения также '
  + 'учитываются пробелы, знаки препинания, знаки переноса строки, итд. Если ваше сообщение длиннее, то оно разбивается'
  + ' на несколько СМС: длина каждого СМС при этом становится 67 русских символов. На телефоне получателя эти СМС'
  + ' склеиваются вместе и отображаются как единое целое благодаря техническим данным, которые вставляются в каждое СМС.';

/**
 * @description Плейсхолдер для поля с выбором даты.
 * @type {string}
 */
const PLACEHOLDER_DATE = '_ _ . _ _ . _ _ _ _';
/**
 * @description Разрешить получение списка ошибок для поля ввода.
 * @param {string} cause Имя поля ввода.
 * @returns {function}
 */
const resolveInputErrors = (cause) => (vm) => (
  cause in vm.violations ? vm.violations[cause] : []
);

/**
 * @description Форма создания шаблона СМС.
 * @type {Vue}
 */
export default {
  smsChannelDescription: SMS_CHANNEL_DESCRIPTION,
  placeholderDate: PLACEHOLDER_DATE,
  sexMale: 1,
  sexFemale: 2,
  sexNone: 3,
  eventUpcomingVisit: 'upcoming-visit',
  eventPastVisit: 'past-visit',
  eventByDate: 'by-date',
  eventBirthDate: 'birth-date',
  eventCreateAppointment: 'create-appointment',
  eventChannelMessenger: 'messengers',
  components: {
    MultipleAutocompleteInput,
    InputCheckbox,
    AutocompleteInput,
    DatePickerDialog,
    DateTimePicker,
    TextareaLengthLimitation,
    InputText,
    TheSelect,
    ...templateFragmentComponents,
  },
  computed: {
    /**
     * @description Достигнут лимит для заполнения поля "Текст сообщения".
     * @returns {boolean}
     */
    isMaxLengthRough() {
      return this.maxLengthText <= this.roughValue.length;
    },
    /**
     * @description Максимальная длина текста.
     * @returns {number}
     */
    maxLengthText() {
      return this.isEnableAutoConfirm ? 255 : 400;
    },
    /**
     * @description Есть возможность включить "Автоподтверждение".
     * @returns {boolean}
     */
    canEnableAutoConfirm() {
      return this.eventId === this.$options.eventUpcomingVisit
        && ['sms'].includes(this.selectedChannel) !== true;
    },
    /**
     * @description Показывать ли опции для "Автоподтверждения".
     * @returns {Boolean}
     */
    isShowAutoConfirmOptions() {
      return this.isEnableAutoConfirm;
    },
    /**
     * @description Выбран канал рассылки "Мессенджеры".
     * @returns {boolean}
     */
    isSelectedMessengersChannel() {
      return this.selectedChannel === this.$options.eventChannelMessenger;
    },
    nameInputErrors: resolveInputErrors('input_name'),
    refuseTextInputErrors: resolveInputErrors('input_refuse_text'),
    confirmTextInputErrors: resolveInputErrors('input_confirm_text'),
    fragmentsInputErrors: resolveInputErrors('input_fragments'),
    channelsInputErrors: resolveInputErrors('channels'),
    eventInputErrors: resolveInputErrors('input_event'),
    dispatchTimeInputErrors: resolveInputErrors('input_dispatch_time'),
    serviceInputErrors: resolveInputErrors('input_service'),
    funnelInputErrors: resolveInputErrors('input_funnel'),
    stageInputErrors: resolveInputErrors('input_stage'),
    dispatchRoutingInputErrors: resolveInputErrors('dispatch_routing'),
    /**
     * @description Показывать блок настроек.
     * @returns {boolean}
     */
    shownBlockOptions() {
      return this.eventId !== this.$options.eventUpcomingVisit
        && this.eventId !== this.$options.eventPastVisit;
    },
    /**
     * @description Показывать настройки.
     * @returns {boolean}
     */
    shownOptions() {
      return this.eventId === this.$options.eventByDate;
    },
    /**
     * @description Выбран CMC-канал рассылки.
     * @returns {boolean}
     */
    isSelectSmsChannel() {
      return this.selectedChannel === 'sms';
    },
    /**
     * @description Отображаемый заголовок выбранного периода.
     * @return {string}
     */
    periodTitle() {
      const [start, end] = this.period.map((date) => formatDate(date));
      if (!end) {
        return `${start}  —  ${start}`;
      }
      return `${start}  —  ${end}`;
    },
    /**
     * @description Типы фрагментов шаблона.
     * @type {any[]}
     */
    fragmentTypes() {
      return List
        .from(this.events)
        .find(({ id }) => this.eventId === id)
        .bind((event) => Maybe.fromEmpty(event.template_fragments))
        .toList()
        .bind(List.fromArray)
        .filter(this.hasFragmentTypeByName)
        .map(this.mergeWithFragmentParams)
        .toArray();
    },
    dispatchTimes() {
      return List
        .from(this.events)
        .find(({ id }) => this.eventId === id)
        .map(({ times }) => times)
        .toList()
        .bind(List.fromArray);
    },
    /**
     * @description Этапы выбранной воронки.
     */
    funnelStageOptions() {
      return this.stageOptions.flatMap(
        (option) => (this.funnel === option.funnel ? [option] : []),
      );
    },
    /**
     * @description Типы фрагментов шаблона без текста.
     * @type {any[]}
     */
    fragmentTypesWithoutText() {
      const orderBy = ({ group: left }, { group: right }) => left.localeCompare(right);
      return this.fragmentTypes.filter((fragment) => fragment.id !== 'Текст').sort(orderBy);
    },
    /**
     * @description Имеются фрагменты.
     * @type {boolean}
     */
    hasFragments() {
      return this.fragmentTypes.length > 0;
    },
    /**
     * @description Позиция последнего фрагмента.
     * @type {number}
     */
    lastPosition() {
      return Maybe
        .fromUndefined(this.fragments.slice(-1).shift())
        .cata(() => 0, (item) => item.position);
    },
    /**
     * @description Значимые поля.
     * @type {any}
     */
    meaningfulFields: (vm) => ({
      name: vm.name,
      fragments: vm.fragments,
      eventId: vm.eventId,
      selectedChannel: vm.selectedChannel,
      dispatchTime: vm.dispatchTime,
      period: vm.period,
      sexId: vm.sexId,
      repeatable: vm.repeatable,
      service: vm.service,
      funnel: vm.funnel,
      stage: vm.stage,
      sendOnWeekends: vm.sendOnWeekends,
    }),
    variables() {
      return this.fragments.filter((fragment) => fragment.id !== 'Текст');
    },
    /**
     * @description Отображать селектор выбора даты отправки.
     * @returns {boolean}
     */
    showDispatchTimeSelector() {
      return this.dispatchTimes.size() > 0
        && (
          this.eventId === this.$options.eventUpcomingVisit
            || this.eventId === this.$options.eventPastVisit
        );
    },
    /**
     * @description Отображать количество уведомляемых пользователей.
     * @returns {boolean}
     */
    showCountNotifiablePatients() {
      return this.eventId !== this.$options.eventUpcomingVisit
        && this.eventId !== this.$options.eventPastVisit;
    },
  },
  created() {
    if (this.initialEvent === '') {
      this
        .events
        .slice(0, 1)
        .forEach(({ id }) => { this.eventId = id; });
    }
    if (this.initialChannel.length === 0) {
      this
        .channels
        .slice(0, 1)
        .forEach((item) => { this.selectedChannel = item.value; });
    }
    this.onChangeOptions();
  },
  data() {
    return {
      /**
       * @description Текст кнопки "Подтверждения" записи, при авто подтверждении.
       * @type {String}
       */
      autoConfirmTextConfirm: this.initialAutoConfirmTextConfirm,
      /**
       * @description Текст кнопки "отмены/переноса" записи, при авто подтверждении.
       * @type {String}
       */
      autoConfirmTextRefuse: this.initialAutoConfirmTextRefuse,
      /**
       * @description Включёно ли авто подтверждение.
       * @type {Boolean}
       */
      isEnableAutoConfirm: this.initialIsEnableAutoConfirm,
      sendOnWeekends: this.initialSendOnWeekends,
      cursorPosition: 0,
      eventId: this.initialEvent,
      sexId: this.initialSexId,
      fragments: this.initialFragments,
      name: this.initialName,
      roughValue: this.getStringByFragments(this.initialFragments),
      patients: [],
      selectedPatients: [],
      period: this.initialPeriod,
      selectedChannel: this.initialChannel,
      selectedDispatchRouting: this.initialDispatchRouting,
      dispatchTime: this.initialDispatchTime,
      repeatable: this.initialRepeatable,
      service: this.initialService,
      funnel: this.initialFunnel,
      stage: this.initialStage,
      sexOptions: [
        {
          title: 'Мужской',
          value: this.$options.sexMale,
        },
        {
          title: 'Женский',
          value: this.$options.sexFemale,
        },
        {
          title: 'Не указан',
          value: this.$options.sexNone,
        },
      ],
    };
  },
  emptyEventId: '',
  methods: {
    /**
     * @description Очистить параметры опций.
     * @returns {void}
     */
    clearOptions() {
      this.sexId = '';
      this.period = [];
      this.repeatable = false;
      this.service = '';
      this.funnel = '';
      this.stage = '';
      this.isEnableAutoConfirm = false;
      if (this.eventId === this.$options.eventByDate) {
        this.dispatchTime = new Date().toISOString();
      } else {
        this.dispatchTime = '';
      }
    },
    /**
     * @description Обработать закрытие диалога выборы даты.
     * @returns {void}
     */
    onCloseDatePickerDialog() {
      if (this.period.length === 1) {
        const [left] = this.period;
        this.onInputPeriod([left, left]);
      }
    },
    /**
     * @description Обработать изменение периода.
     * @param {Date[]} value
     * @returns {void}
     */
    onInputPeriod(value) {
      this.period = value.sort(
        (first, second) => Number(first.getTime() > second.getTime()),
      );
      this.onChangeOptions();
    },
    /**
     * @description Обработать изменение опций плана.
     * @returns {void}
     */
    onChangeOptions() {
      if (this.isSelectSmsChannel) {
        const request = this.makeRequest();
        this.$emit('change-options', request);
      }
    },
    /**
     * @description Обработать изменение события.
     * @returns {void}
     */
    onChangeEvent() {
      this.clearOptions();
      this.onChangeOptions();
    },
    /**
     * @description Обработать изменения времени отправки
     * @param {string} time
     */
    onChangeTime(time) {
      this.dispatchTime = time;
    },
    /**
     * @description Обработать добавление фрагмента.
     * @param {any} fragment Фрагмент.
     * @returns {void}
     */
    onAddFragment(fragment) {
      const hasSpaceForFragment = this.roughValue.length
        + fragment.name.length < this.maxLengthText;
      if (!hasSpaceForFragment) {
        return;
      }
      this.cursorPosition = Math.min(this.cursorPosition, this.roughValue.length);
      const before = this.roughValue.slice(0, this.cursorPosition);
      const after = this.roughValue.slice(this.cursorPosition);
      this.roughValue = `${before}{${fragment.name}} ${after}`;
      this.onUpdateRoughValue(this.roughValue);
      this.$nextTick(() => {
        const textarea = this.$refs.textarea.$el.querySelector('textarea');
        if (textarea) {
          this.cursorPosition += `{${fragment.name}} `.length;
        }
      });
    },
    /**
     * @description Обработать отправку данных шаблона.
     * @returns {void}
     */
    onSubmit() {
      const request = this.makeRequest();
      this.$emit('submit', request);
    },
    /**
     * @description Прослушка ввода CRM-воронки
     * @returns {void}
     */
    handleFunnelInput() {
      this.resetStage();
      this.onChangeOptions();
    },
    /**
     * @description Подготовить запрос.
     * @returns {NotificationPlanCreationRequest}
     */
    makeRequest() {
      const fragments = this.fragments.map(
        ({ id, position, value = '' }) => ({ id, position, value }),
      );
      return new NotificationPlanCreationRequest(
        this.id,
        this.name,
        fragments,
        this.eventId,
        this.selectedChannel,
        this.selectedDispatchRouting,
        this.dispatchTime,
        this.period,
        this.sexId,
        this.repeatable,
        this.service,
        this.funnel,
        this.stage,
        this.isEnableAutoConfirm,
        this.autoConfirmTextConfirm,
        this.autoConfirmTextRefuse,
        this.sendOnWeekends,
      );
    },
    /**
     * @description Установить фрагменты.
     * @param items
     */
    setFragments(items) {
      const orderBy = ({ position: left }, { position: right }) => left - right;
      this.fragments = [...items]
        .sort(orderBy)
        .map((fragment, index) => ({ ...fragment, position: index + 1 }));
    },
    /**
     * @description Сбросить выбор этапа.
     * @returns {void}
     */
    resetStage() {
      this.stage = '';
    },
    /**
     * @description Обновить приблизительное значение.
     * @param {string} value
     */
    onUpdateRoughValue(value) {
      const fragments = value
        .split(/({.*?})/)
        .filter((s) => !!s)
        .map((fragment, index) => {
          if (this.fragmentTypes.some((type) => `{${type.id}}` === fragment)) {
            const result = { ...this.fragmentTypes.find((type) => `{${type.id}}` === fragment) };
            result.position = index + 1;
            return result;
          }
          const result = { ...this.fragmentTypes.find((type) => type.id === 'Текст') };
          result.position = index + 1;
          result.value = fragment;
          return result;
        });
      this.setFragments(fragments);
      this.roughValue = value;
    },
    /**
     * @description Обновить позицию курсора.
     * @param  {number} value
     */
    onUpdateCursorPositions(value) {
      this.cursorPosition = value;
    },
    /**
     * @description Получить строку по фрагментам.
     * @param {array} fragments
     * @returns {string}
     */
    getStringByFragments(fragments) {
      return fragments.map((fragment) => {
        if (fragment.value) return fragment.value;
        return `{${fragment.id}}`;
      }).join('');
    },
  },
  mixins: [
    notifierMixin,
    smsTemplateMixin,
    formMeaningfulFieldsMixin,
  ],
  name: 'FormNotificationPlan',
  props: {
    /**
     * @description Отправлять в выходные.
     * @type {Boolean}
     */
    initialSendOnWeekends: { type: Boolean, default: () => true },
    /**
     * @description Включёно ли авто подтверждение.
     * @type {Boolean}
     */
    initialIsEnableAutoConfirm: { type: Boolean, default: () => false },
    /**
     * @description Текст кнопки "Подтверждения" записи, при авто подтверждении.
     * @type {String}
     */
    initialAutoConfirmTextConfirm: { type: String, default: () => '' },
    /**
     * @description Текст кнопки "отмены/переноса" записи, при авто подтверждении.
     * @type {String}
     */
    initialAutoConfirmTextRefuse: { type: String, default: () => '' },
    /**
     * @description Уведомляемые события.
     * @type {any[]}
     */
    events: { type: Array, required: true },
    /**
     * @description Каналы отправки.
     * @type {Array}
     */
    channels: { type: Array, required: true },
    /**
     * @description Количество уведомляемых пациентов.
     * @type {Number}
     */
    countNotifiablePatients: { type: Number, default: () => 0 },
    /**
     * @description Описание к уведомляемым пациентам.
     * @type {String}
     */
    descriptionNotifiablePatients: { type: String, default: () => '' },
    id: { type: String, default: () => null },
    initialName: { type: String, default: () => '' },
    initialFragments: { type: Array, default: () => [] },
    initialEvent: { type: String, default: () => '' },
    initialDispatchTime: { type: String, default: () => '' },
    initialChannel: { type: String, default: () => '' },
    initialDispatchRouting: { type: Array, default: () => [] },
    initialSexId: { type: String, default: () => '' },
    initialPeriod: { type: Array, default: () => [] },
    initialRepeatable: { type: Boolean, default: () => false },
    initialService: { type: String, default: () => '' },
    initialFunnel: { type: String, default: () => '' },
    initialStage: { type: String, default: () => '' },
    serviceOptions: { type: Array, default: () => [] },
    funnelOptions: { type: Array, default: () => [] },
    stageOptions: { type: Array, default: () => [] },
    dispatchRoutingOptions: { type: Array, default: () => [] },
    /**
     * @description Список нарушений.
     * @type {string[]}
     */
    violations: {
      default: () => {},
      type: Object,
    },
  },
};
</script>
<style lang="scss" scoped>
@use "@/scss/buttons";

::v-deep .textarea-length-limitation {
  &__textarea {
    min-height: 40px;
    max-height: 220px;
  }
}

.notification-center-page {
  h4 {
    color: #192a3e;
    font-weight: 500;
  }
  &__form {
    display: grid;
    grid-template-columns: 1fr;
    gap: 28px;
    margin-top: 24px;
    &__section {
      position: relative;
      display: grid;
      row-gap: 20px;
      height: fit-content;
      &:not(:last-of-type) {
        padding-bottom: 28px;
        &::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: -27px;
          right: -27px;
          height: 1px;
          background-color: var(--border-color);
        }
      }
    }
    &__group-row {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 14px 10px;
    }
  }
  &__date-time-select {
    padding: 0;
  }
  &__switch,
  &__chips {
    display: flex;
    align-items: center;
    gap: 15px;
  }
  &__chips {
    flex-wrap: wrap;
    gap: 10px 4px;
  }
  &__chip {
    ::v-deep .v-chip__content {
      padding: 0;
    }
  }
  .recipients-date {
    display: grid;
    gap: 3px;
    &__button {
      width: fit-content;
      color: var(--action-color);
      font-size: 18px;
      font-weight: 500;
      text-align: left;
      line-height: 22px;
      white-space: nowrap;
      border-bottom: 1px dashed;
      cursor: pointer;
      &:hover {
        border-bottom: 1px dashed transparent;
      }
    }
    &__title {
      display: block;
      font-size: 12px;
      font-weight: 400;
      line-height: 16px;
      color: var(--unfocus-color);
    }
    &__button-calendar {
      display: inline-grid;
      width: 100%;
      height: 40px;
      padding: 8px 10px;
      padding-right: 40px;
      color: #192A3E;
      text-align: left;
      background: url("@/assets/img/calendar.svg") no-repeat;
      background-position: right 12px center;
      background-size: 25px 25px;
      border-radius: var(--input-border-radius);
      border: 1px solid var(--border-color);
      &__placegolder {
        color: var(--placeholder-color);
      }
      span {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }
  }
}

.template {
  &__add-fragment,
  &__event,
  &__name {
    width: min(100%, 40rem);
  }
  &__fragment {
    cursor: grab;
    width: max(60%, 40rem);
  }
  &__submit {
    @include buttons.btn-blue(10rem, 3rem, 1rem);
  }
  &__cancel {
    @include buttons.btn-transparent(10rem, 3rem, 1rem);
  }
  &__control-buttons {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px;
    max-width: 330px;
    width: 100%;
    margin: 6px 0 0 auto;
  }
}

@media screen and (max-width: 480px) {
  .notification-center-page {
    &__form {
      &__group-row {
        grid-template-columns: 1fr;
      }
    }
  }
  .template{
    &__add-fragment {
      display: grid;
      gap: 10px;
    }
  }
  ::v-deep .add-fragment__add {
    text-align: left;
  }
}

@media screen and (max-width: 380px) {
  .template {
    &__control-buttons {
      grid-template-columns: 1fr;
    }
    &__cancel,
    &__submit {
      width: 100%;
    }
  }
}
</style>
